import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import SelectTenant from '../../accounts/datatransfer/components/SelectTenant_subs'
import { getsuscriptionglobal,getsuscription } from '../../../ctr-r/troubleshooting/request/request'
import { reg } from '../../newctxForm/components/lista_regiones_zona'
const API_URL = process.env.REACT_APP_API_URL


type x=
{
  id: string
  name:string
  description:string
}

type objetocontinente ={
  name: string,
  code: string,
  type: string,
  label: string,
 continent: string
}

const Modaldeploy = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)

  const{currentUser}= useAuth()
 
  const [cloud,setcloud] = useState('')
  const [loctype,setloctype] =useState('')
  const [continente,setcontinente]= useState('')
  const [region,setRegion]=useState('')
  const [sus,setsus]=useState('')
  const [listaSelectContinente,setcontinentes]= useState<objetocontinente[]>([])
  const [listaRegion,setlistaRegion]= useState<objetocontinente[]>([])
 
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  ////
 
  const [VPNGB,setVPNGB]= useState('')
  const [CPRGB,setCPRGB]= useState('')
  const [EDGGB,setEDGB]= useState('')
  const [redundanceOption, setredundance] = useState('');
  const [ngfw, setngfw] = useState<boolean>();


  const handleOptionChange = (option: string) => {
    setredundance(option);
  };

  const ngfwchange = (option: boolean) => {
    setngfw(option);
  };

  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const listadecontinentes:Array<object>=[]
    listadecontinentes.push(Object.keys(reg))
  
  const listadeobjetoscontinentes:Array<any>=[]
  listadeobjetoscontinentes.push(Object.values(reg))

  useEffect( () => {
    //listadeZonas.splice(0,listadeZonas.length)
    const lista=[]
    for (const continenteindividual of listadeobjetoscontinentes){
      for (const y of continenteindividual){
        if(loctype === y.type){
          lista.push(y.name)
          }
      }
    }
    setcontinentes(lista)
  }, [loctype])
 
  useEffect( () => {
    //listadeZonas.splice(0,listadeZonas.length)
    const listareg=[]
    for (const continenteindividual of listadeobjetoscontinentes){
      for (const R of continenteindividual){
        if(continente === R.name){
          listareg.push(R.code)
          }
      }
    }
    setlistaRegion(listareg)
  }, [continente])


  const [suscription,setsuscrption]=useState<any>()

  useEffect( () => {
    if (currentUser?.ListPermiso?.includes('Tenant.list')){
       if(tenant ===0){
          getsuscription().then(response=>{
              setsuscrption(response.data)
          })
       }
       else if(tenant !==0){
         getsuscriptionglobal(tenant).then(response=>{
              setsuscrption(response.data)
          })
       }
      }
      }, [tenant])

   
  


  


  


  /************************************************************************* */
  

    //const navigate = useNavigate();

    const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{
     console.log(props)
      if(props.id===null){
        const body ={
          tenant:tenant,
          cloud:cloud,
          loctype:loctype,
          continente:continente,
          region:region,
          vpn:VPNGB,
          cpr:CPRGB,
          edg:EDGGB,
          HA:redundanceOption,
        }
        if(tenant===0){
          console.log(body)
       /* await axios.post(API_URL+'/v1/rol/', body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Role has created',
          showConfirmButton: false,
          timer: 1500
        
        })
        window.location.reload();

      });*/
      }
      else{
        console.log(body)

        await axios.get(API_URL+'/v1/suscription')
        .then(res=>
        console.log(res.data,'esta es la data')  
        )

        /*await axios.post(API_URL+'/v1/rol/?tenantId='+tenant, body)
        .then(res=>{ Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Your Role has created',
          showConfirmButton: false,
          timer: 1500
        })
        window.location.reload();
      });*/
      }
      //navigate('/support/SeeRequest')
    }
  }
    catch(error:any){
      console.log(error)

    }

    
   }

  

  ///////////////////////////////////////////////

  

    
  


   

  return (
    
    <>


      {props.id === null &&
      <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            {/* begin::Modal dialog */}
            <div className='modal-dialog modal-dialog-centered mw-800px'>
              {/* begin::Modal content */}
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                {/* begin::Modal body */}
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
            {/* begin::Heading */}
            {/*<Card4
            icon='/media/svg/files/NubeTD.svg'
            title=' '
            description=''></Card4>*/}
            <div className='text-center mb-5'>
            <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Deployment data</h1>
            </div>
            {/* begin::Heading */}

            {/* begin::Login options */}

            <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                <div className='text-info'>
                  Please fill in the necessary fields to carry out the deployment.
                </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div className='col'style={{ margin: 'auto', display: 'inline-block' }}>
                <SelectTenant />
              </div>
              <div className='col'style={{ margin: 'auto', display: 'inline-block' }}>
              {suscription&&
              <>
              <label className='form-label fs-6 fw-bolder text-dark required form-label' >Suscription</label>
              <select 
                style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                required
                className="form-select form-select-solid text-marino f-parrafo border-gray-400 " aria-label="Select example"
                value={sus}
                onChange={(e) => setsus((e.target.value))}
                >
                <option  hidden> Select Suscription</option>
                {suscription.map((subs:any,i:any)=>
                  <option key={i} value={subs.id}>{subs.purchaseOrden}</option>
                )}
              </select>
              </>}
              </div>
            </div>     
            <br />      
            {/* Campos solicitud */}
            <div className='fv-row '>
            <div className='row '>
              <div className='col-lg-3'>
                <label className='form-label fs-7 fw-bolder text-marino required form-label f-parrafo' >Select Cloud</label>
                <select 
                    style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                    required
                    className="form-select form-select-solid  text-marino f-parrafo border-gray-400 " aria-label="Select example"
                    value={cloud}
                    onChange={(e) => setcloud((e.target.value))}
                    >
                    <option  key={'0'} hidden> Select cloud</option>
                    <option key={'1'}  value="AWS">AWS</option>
                    <option key={'2'} value="OCI">OCI</option>
                    <option key={'3'} value="AZR">AZR</option>
                    <option key={'4'} value="GCP">GCP</option>
                  </select>
              </div>
              <div className='col-lg-3'>
                <label className='form-label fs-7 f-parrafo fw-bolder text-marino required form-label' >Location type</label>
                <select 
                    style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                    required
                    className="form-select form-select-solid  text-marino f-parrafo border-gray-400 " aria-label="Select example"
                    value={loctype}
                    onChange={(e) => setloctype((e.target.value))}
                    >
                    <option  hidden> Select type</option>
                    {cloud ==='AWS'&&
                    <>
                    <option value="AWS Region">Region</option>
                    <option  value="AWS Local Zone">Local Zone</option>
                    <option  value="AWS Wavelength Zone">Wavelength Zone</option>
                    </>}
                  </select>
              </div>
              <div className='col-lg-3'>
                <label className='form-label fs-7 fw-bolder text-marino f-parrafo required form-label' >Select Continent</label>
                <select 
                    style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                    required
                    className="form-select form-select-solid f-parrafo  text-marino border-gray-400 " aria-label="Select example"
                    value={continente}
                    onChange={(e) => setcontinente((e.target.value))}
                    >
                    <option  hidden >Choose Continent</option>
                    {cloud ==='AWS'&& listaSelectContinente.map((a:any,i:any)=>
                      <option key={i} value={a}>{a}</option>
                    )}
                  </select>
              </div>
              
              <div className='col-lg-3'>
                {continente ===''&& <label className='form-label text-marino f-parrafo fs-7 fw-bolder text-marino f-parrafo required form-label' >Choose</label>}
                {continente !==''&& loctype === "AWS Region" &&<label className='form-label text-marino f-parrafo fs-7 fw-bolder  required form-label' >Choose a Region</label>}
                {continente !==''&& loctype === "AWS Local Zone" &&<label className='form-label text-marino f-parrafo fs-7 fw-bolder  required form-label' >Choose a Local Zone</label>}
                {continente !==''&& loctype === "AWS Wavelength Zone" &&<label className='form-label text-marino f-parrafo fs-7 fw-bolder  required form-label' >Wavelength Zone</label>}
                <select 
                    style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                    required
                    className="form-select form-select-solid text-marino f-parrafo border-gray-400 " aria-label="Select example"
                    value={region}
                    onChange={(e) => setRegion((e.target.value))}
                    >
                    <label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Region</label>
                    <option  hidden> Select Region</option>
                    {cloud ==='AWS'&& listaRegion.map((reg:any,i:any)=>
                      <option key={i} value={reg}>{reg}</option>
                    )}
                  </select>
              </div>
            </div>
          </div>
          <br />
                               

                  <h5 className='f-parrafo text-marino text-center'>GB per Plan</h5>
                  <div className='row'>
                    <div className='col'>
                      <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="descripcion">VPN</label>
                      <input type="text" 
                      name='name' 
                      className='form-control form-control-solid border-gray-300 f-parrafo' 
                      id='descripcion'
                      value={VPNGB}
                      onChange={(e:any) => setVPNGB(e.target.value)}
                      />
                    </div>

                    <div className='col'>
                      <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="descripcion">CPR</label>
                      <input type="text" 
                      name='name' 
                      className='form-control form-control-solid border-gray-300 f-parrafo' 
                      id='descripcion'
                      value={CPRGB}
                      onChange={(e:any) => setCPRGB(e.target.value)}
                      />
                    </div>

                    <div className='col'>
                      <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="descripcion">Edge</label>
                      <input type="text" 
                      name='name' 
                      className='form-control form-control-solid border-gray-300 f-parrafo' 
                      id='descripcion'
                      value={EDGGB}
                      onChange={(e:any) => setEDGB(e.target.value)}
                      />
                    </div>

                  </div>

                  <br />
                  <p className='text-center fw-bolder f-parrafo'>Select High Availability Option</p>

                  <div className="fv-row mb-3">
                    <div className="form-check form-check-custom form-check-solid">
                          <input
                          className='form-check-input border border-azul'
                          type='radio'
                          checked={redundanceOption === 'NO'}
                          onChange={() => handleOptionChange('NO')}
                          id='NO'
                        />
                        <label className="form-check-label text-marino f-parrafo fw-bolder" >
                          Without high availability
                        </label>
                    </div>
                  </div>

                  

                  <div className="fv-row mb-3">
                    <div className="form-check form-check-custom form-check-solid">
                        <input
                          className='form-check-input border border-azul'
                          type='radio'
                          checked={redundanceOption === 'HA'}
                          onChange={() => handleOptionChange('HA')}
                          id='Redundance'
                        />
                        <label className="form-check-label text-marino f-parrafo fw-bolder" >
                          High Availability
                        </label>
                    </div>
                  </div>

                  <br />
                  <p className='text-center fw-bolder f-parrafo'>Do you want to add a NGFW security stage?</p>

                  <div className="fv-row mb-3">
                    <div className="form-check form-check-custom form-check-solid">
                          <input
                          className='form-check-input border border-azul'
                          type='radio'
                          checked={ngfw === true}
                          onChange={() => ngfwchange(true)}
                        />
                        <label className="form-check-label text-marino f-parrafo fw-bolder" >
                          YES
                        </label>
                    </div>
                  </div>

                  

                  <div className="fv-row mb-3">
                    <div className="form-check form-check-custom form-check-solid">
                        <input
                          className='form-check-input border border-azul'
                          type='radio'
                          checked={ngfw === false}
                          onChange={() => ngfwchange(false)}
                        />
                        <label className="form-check-label text-marino f-parrafo fw-bolder" >
                          NO
                        </label>
                    </div>
                  </div>

                  
                  <br />
                  
                  
                        {/* end::Label */}
                      {/* end::Radio */}

                  {/* begin::Action */}
                  <br />
                  <div className='d-grid mb-10 justify-content-center'>

                    <div className='row'>
                      <div className='col'>
                        <button
                            type='submit'
                            id='kt_sign_in_submit'
                            className='btn btn-primary'
                    
                            
                          >
                            {!loading && <span className='indicator-label'>Send</span>}
                            {loading && (
                              <span className='indicator-progress' style={{display: 'block'}}>
                              Please wait...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            )}
                          </button>
                      </div>
                      <div className='col'>
                          <button
                          style={{width:'200px'}}
                          className='btn text-pink border border-pink'
                          onClick={() => props.setID(undefined)}

                          >
                            Cancel
                          </button>
                        </div>
                    </div>
                    
                    
                  </div>
                  {/* end::Action */}

                </form>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }   
      
    </>
  )
}
export {Modaldeploy}